import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { FieldPathByValue } from 'react-hook-form';

import { TermostatstyringGulv } from '../../../../../../../components/registering/utils/registerEnums';
import { OppvarmingFormData } from '../../../types';
import { useOppvarmingFormContext } from '../../utils';

type TermostatstyringGulvPath = FieldPathByValue<OppvarmingFormData, TermostatstyringGulv>;

interface Props {
  name: TermostatstyringGulvPath;
}

export const TermostatstyringGulvRadio: FC<Props> = ({ name }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.common.termostatstyringGulv' });
  const { register, getFieldState } = useOppvarmingFormContext();
  const { error } = getFieldState(name);

  return (
    <Fieldset>
      <Fieldset.Legend>{t('label')}</Fieldset.Legend>
      <Radio
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${TermostatstyringGulv.Trinnbryter}`)}
        value={TermostatstyringGulv.Trinnbryter}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${TermostatstyringGulv.TrinnlosRegulering}`)}
        value={TermostatstyringGulv.TrinnlosRegulering}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${TermostatstyringGulv.TermostatstyrtUtenTidsstyring}`)}
        value={TermostatstyringGulv.TermostatstyrtUtenTidsstyring}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${TermostatstyringGulv.TermostatstyrtMedTidsstyring}`)}
        value={TermostatstyringGulv.TermostatstyrtMedTidsstyring}
        aria-invalid={!!error}
      />

      <Radio
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${TermostatstyringGulv.Ukjent}`)}
        value={TermostatstyringGulv.Ukjent}
        aria-invalid={!!error}
      />
      {error?.message && <ValidationMessage data-color="danger">{error.message}</ValidationMessage>}
    </Fieldset>
  );
};
